import { Navigate, Outlet } from "react-router";
import { LOCALE, MODIFY, useFoodpilotContext } from "src/context/FoodpilotContext";

export const LocaleManagementProtection = () => {
    const { canUser } = useFoodpilotContext();

    if (!canUser(MODIFY, LOCALE)) {
        return <Navigate to="/settings" replace />;
    }

    return <Outlet />;
};
